import React from "react";
import { render } from "react-dom";
import { observe } from "selector-observer";
import { Image } from "../../../../scripts/react/Image";

export const FeaturedItem = (props) => {
    const { url, category, description, externalDescription, imageSrc, title, imageAlt } = props;

    return (
      <div className="featured-item-container">
          <a title={imageAlt} href={url} className="preview-image">
              <Image src={imageSrc} alt={imageAlt} />
              {
                  category && <div className="category-container">
                        <span className="category">{category}</span>
                  </div>
              }
              { title && <h3>{title}</h3> }
              { description && <p className="preview-desc">{description}</p> }
              { externalDescription && <p className="preview-desc">{externalDescription}</p> }
          </a>
      </div>
  );
};



export const FeaturedItems = ({ cards }) => {
    if (!cards?.length) return null;
    if (cards.length == 2) {
        return (
            <div className="row-two">
                {cards.map((card, index) => (
                    <FeaturedItem {...card} key={index} />
                ))}
            </div>
        )
    }
    return (
        <div className="row">
            {cards.map((card, index) => (
                <FeaturedItem {...card} key={index} />
            ))}
        </div>
  );
};

 document.addEventListener("readystatechange", () => {
     if (document.readyState === "complete") {
         observe('[data-component="featureditems"]', {
             add(element) {
                 const { dataset } = element as HTMLElement;
                 const { propsId } = dataset;
                 const componentData = window.ucsdh[`featureditems_${propsId}`];
                 render(<FeaturedItems {...componentData} />, element);
             },
         });
     }
 });
